import React from 'react';
import { FillableContainer } from './FillableContainer';
import { SpinnerBars } from './SpinnerBars';

export interface Props {
  /**
   * Whether the loading bars should fill its container. Defaults to `true`.
   */
  fill?: boolean;
  /**
   * The height and width of the loading bars.
   */
  size?: number;
}

/**
 * A simple loading animation.
 */
export const Bars = React.forwardRef<HTMLDivElement, Props>(({ fill = true, size = 32 }, ref) => (
  <FillableContainer innerRef={ref} fill={fill}>
    <SpinnerBars size={size} />
  </FillableContainer>
));
